import { useEffect, useState } from "react";
import React from "react";
import "../Assets/Css/Teachers.css";
import "../Assets/Css/Principal.css";
import prevArrow from "../Assets/Images/Dashboard/prev_icon.png";
import nextArrow from "../Assets/Images/Dashboard/next_icon.png";

import upArrow from "../Assets/Images/Dashboard/up_arrow.png";
import downArrow from "../Assets/Images/Dashboard/down_arrow.png";
import { toast } from "react-toastify";

import Sidebar from "../Component/Sidebar";
import Loader from "../Component/Loader";
import { Link } from "react-router-dom";
import {
  TEACHER_LIST_GET_API,
  API_START_POINT,
  SCHOOL_LIST_GET_API,
  CREATE_PRINCIPAL_API,
  PRINCIPALS_LIST_GET_API,
} from "../Component/AllApi";
import Select from "react-select";
import ExportToExcel from "../Component/ExportToExcel";

const Principal = () => {
  const itemsPerPage = 10;

  const [user, setUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  // const [toggleStates, setToggleStates] = useState(

  //   []
  // );
  const [token, setToken] = useState(localStorage.getItem("authToken"));
  const [userRole, setUserRole] = useState(localStorage.getItem("user_role"));

  const [newPrincipal, setNewPrincipal] = useState({
    name: "",
    phone: "",
    email: "",
    schoolIds: "",
  });
  const [schools, setSchools] = useState([]);
  const [errors, setErrors] = useState({});

  // Fetch the list of schools
  useEffect(() => {
    const fetchSchoolList = async () => {
      var token = localStorage.getItem("authToken");
      try {
        const response = await fetch(SCHOOL_LIST_GET_API, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch school list");
        const data = await response.json();
        const formattedSchools = data.allSchools.map((school) => ({
          id: school.school_id,
          name: school.school_name,
        }));
        setSchools(formattedSchools); // Assuming API response is in this format
        // console.log(data.allSchools);
      } catch (error) {
        console.error("Error fetching school list:", error);
      }
    };
    fetchSchoolList();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    // console.log('data is fetching...');
    var token = localStorage.getItem("authToken");
    // console.log('new token: ',token)
    try {
      const response = await fetch(PRINCIPALS_LIST_GET_API, {
        method: "GET",
        headers: {
          Authorization: `bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Something went wrong");
      }
      // const { allPrincipals } = await response.json();
      const data = await response.json();

      // const data = await response.json()
      // console.log(" data: ", data);

      setUser(data.allPrincipals);
      // console.log("allPrincipals: ", data.allPrincipals);

      //prev code
      // const initialToggleState = allPrincipals.map(
      //   (princi) => princi.princi_is_active === 1
      // );

      // new code
      // const initialToggleState = data.allPrincipals.reduce((acc, princi) => {
      //   acc[princi.princi_id] = princi.princi_is_active === 1;
      //   return acc;
      // });
      // setToggleStates(initialToggleState);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchData();
  // }, []);
  useEffect(() => {
    // Ensure latest token and userRole are set before fetching data
    setToken(localStorage.getItem("authToken"));
    setUserRole(localStorage.getItem("user_role"));

    if (token && userRole) {
      fetchData();
    }
  }, [token, userRole]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewPrincipal((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  // const handleSchoolChange = (selectedOptions) => {
  //   console.log("data: ",selectedOptions)
  //   const selectedSchoolIds = Array.isArray(selectedOptions)
  //     ? selectedOptions?.map((option) => option.value)
  //     : [];
  //   setNewPrincipal({
  //     ...newPrincipal,
  //     // schoolName: selectedSchools,
  //     schoolIds: selectedSchoolIds,
  //   });
  // };

  const handleSchoolChange = (selectedOption) => {
    console.log("data: ", selectedOption);
    setNewPrincipal({
      ...newPrincipal,
      // schoolIds: selectedOption ? selectedOption.value : "", // Set the selected school's ID
      schoolIds: selectedOption ? [selectedOption.value] : [], // Set the selected school's ID
    });
  };

  const schoolOptions = schools.map((school) => ({
    value: school.id,
    label: school.name,
  }));

  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!newPrincipal.name) {
      newErrors.name = "Name is required";
    }

    // Phone validation (example: should be 10 digits)
    if (!/^\d{10}$/.test(newPrincipal.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }

    // Email validation
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    if (!emailPattern.test(newPrincipal.email)) {
      newErrors.email = "Enter a valid email address";
    }

    // School name validation
    if (!newPrincipal.schoolName) {
      newErrors.schoolName = "Please select a school";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    const token = localStorage.getItem("authToken");
    e.preventDefault();
    if (validateForm()) {
      console.log(newPrincipal);

      // Transform `newPrincipal` to the required API format
      const firstSchool = newPrincipal.schoolIds?.[0];
      const formattedData = {
        princi_name: newPrincipal.name,
        princi_email: newPrincipal.email,
        princi_mobile: newPrincipal.phone,
        // princi_school: newPrincipal.schoolIds?.[0], // Assuming only one school ID is needed
        princi_school: firstSchool, // Assuming only one school ID is needed
        // princi_school: newPrincipal.schoolIds,
      };

      try {
        // Post newPrincipal data to your API to add a principal
        const response = await fetch(CREATE_PRINCIPAL_API, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${token}`,
          },
          body: JSON.stringify(formattedData),
        });
        if (!response.ok) {
          // console.error("Something went wrong");
          throw new Error("Failed to add principal");
          // window.location.reload();
        }
        // Parse the response if needed
        const result = await response.json();
        console.log("Response:", result);

        // Show success message using a toaster
        toast.success("Principal added successfully!");
        setNewPrincipal({ name: "", phone: "", email: "", schoolIds: [] });

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } catch (error) {
        console.error("Error adding principal:", error);
        toast.error("Failed to add principal, Please try again.");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  };

  const handleCancel = () => {
    setNewPrincipal({ name: "", phone: "", email: "", schoolIds: [] });
    setErrors({});
  };

  // let count = 0;
  // toggleStates.map((data) => {
  //   if (data == false) {
  //     count++;
  //   }
  // });

  // localStorage.setItem("teacherCount", count);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
    // fetchData();
  };

  const handleSort = (key) => {
    if (sortKey === key) {
      // If already sorted by this key, toggle the order
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // If sorting by a new key, set it and default to ascending order
      setSortKey(key);
      setSortOrder("asc");
    }
  };
  // const selectedSection = localStorage.getItem("selectedSection");

  // const handleToggle = async (index, princiID) => {

  //   // new code
  //   const newToggleStates = { ...toggleStates };
  //   newToggleStates[princiID] = !newToggleStates[princiID];
  //   setToggleStates(newToggleStates);

  //   try {

  //     const response = await fetch(
  //       `${API_START_POINT}/principals/${princiID}/toggle-active`,
  //       {
  //         method: "PUT",
  //         headers: {
  //           Authorization: `bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           // tra_is_active: newToggleStates[index] ? 1 : 0,
  //           princi_is_active: newToggleStates[princiID] ? 1 : 0,
  //         }),
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error("Failed to Update");
  //     }
  //     fetchData();
  //     // console.log("Toggle state updated for trainer ID", trainerID);
  //   } catch (err) {
  //     console.error("Error occured", err);
  //     alert("Something went wrong. Please try again.");

  //     // new code
  //     newToggleStates[princiID] = !newToggleStates[princiID]; // Revert the change
  //     setToggleStates(newToggleStates);
  //     // fetchData();
  //   }
  // };

  const filteredUsers = user.filter((userData) => {
    const query = searchQuery.toLowerCase();
    return (
      (userData.princi_name &&
        userData.princi_name.toLowerCase().includes(query)) ||
      (userData.school_name &&
        userData.school_name.toLowerCase().includes(query)) ||
      // (userData.tra_address &&
      //   userData.tra_address.toLowerCase().includes(query)) ||
      (userData.princi_mobile && userData.princi_mobile.includes(query))
    );
  });

  const sortedUsers = sortKey
    ? filteredUsers.slice(indexOfFirstItem, indexOfLastItem).sort((a, b) => {
        // Sort function based on the current sort key and order
        const aValue = String(a[sortKey]).toLowerCase();
        const bValue = String(b[sortKey]).toLowerCase();
        if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
        if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
        return 0;
      })
    : filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const totalItems = filteredUsers.length;
  const PagePerItem = Math.min(totalItems - indexOfFirstItem, indexOfLastItem);
  const rangeStart = Math.min((currentPage - 1) * itemsPerPage + 1, totalItems);
  const rangeEnd = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <section className="schoolListSection">
            <div className="sidebody">
              <div className="container">
                {/* Your main_div */}
                <div className="main_div">
                  <div
                    className="schListHeader_div"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {/* Your header_text and search_div */}
                    <div className="schListHeader_text">
                      <p>Principals</p>
                    </div>
                    <div className="d-flex">
                      <div className=" me-4">
                        {/* <button className="btn" onClick={handleOpenPopup}>
                        Add Principal
                      </button> */}
                        {/* {userRole === "Diet" && (
                          <button
                            type="button"
                            class="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          >
                            Add Principal
                          </button>
                        )} */}
                      </div>
                      <div className="d-flex">
                        <div>
                          <ExportToExcel
                            data={user}
                            fileName="Principals_List"
                            sheetName="Principals"
                            columns={[
                              { key: "princi_name", alias: "Principal Name" },
                              { key: "princi_mobile", alias: "Mobile Number" },
                              { key: "princi_email", alias: "Email" },
                              {
                                key: "school_name",
                                alias: "Principal's School",
                              },
                            ]}
                          />
                        </div>
                        <div className="searchBar">
                          <form className="d-flex">
                            <input
                              className="form-control me-2"
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                              onChange={handleSearch}
                              style={{ borderRadius: "12px", border: "none" }}
                            />
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Your content table-responsive */}
                  {sortedUsers?.length < 0 || sortedUsers?.length === 0 ? (
                    <>
                      <p className="progressMainTitle text-center">
                        No data available
                      </p>
                    </>
                  ) : (
                    <div
                      className="card schoolListTableDiv"
                      style={{ border: "none" }}
                    >
                      <div
                        className=" table-responsive  card-body"
                        style={{
                          maxHeight: "750px",
                          // height: "700px"
                        }}
                      >
                        <table className="table table-borderless">
                          <thead
                            style={{ marginBottom: "20px" }}
                            className="thead_div"
                          >
                            <tr>
                              <th
                                style={{ width: "5%" }}
                                className="thead_div_row pb-4"
                              >
                                Sr. No
                              </th>
                              <th
                                scope="col"
                                style={{ width: "20%", textAlign: "left" }}
                                className="thead_div_row pb-4"
                              >
                                Principals &nbsp;
                                <button
                                  className="sort_button"
                                  onClick={() => handleSort("princi_name")}
                                  // style={{marginLeft:"4px"}}
                                >
                                  <img
                                    src={
                                      sortKey === "tra_name" &&
                                      sortOrder === "asc"
                                        ? downArrow
                                        : upArrow
                                    }
                                    className="desc"
                                    style={{ marginRight: "15px" }}
                                    alt="arrows"
                                  />
                                </button>
                              </th>
                              <th
                                scope="col"
                                className="thead_div_row pb-4"
                                style={{ width: "20%" }}
                              >
                                School Name &nbsp;
                                <button
                                  className="sort_button"
                                  onClick={() => handleSort("school_name")}
                                >
                                  {" "}
                                  <img
                                    src={
                                      sortKey === "school_name" &&
                                      sortOrder === "asc"
                                        ? downArrow
                                        : upArrow
                                    }
                                    className="desc"
                                    style={{ marginRight: "15px" }}
                                    alt="arrows"
                                  />
                                </button>{" "}
                              </th>
                              <th
                                scope="col"
                                className="thead_div_row pb-4"
                                style={{ width: "15%" }}
                              >
                                Email Id{" "}
                              </th>
                              <th
                                scope="col"
                                className="thead_div_row pb-4"
                                style={{ width: "15%" }}
                              >
                                Mobile No
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortedUsers.map((userData, index) => (
                              <tr key={index}>
                                <td
                                  className="header_srNo"
                                  style={{ paddingBottom: "36px" }}
                                >
                                  {index + indexOfFirstItem + 1}
                                </td>
                                <td className="d-flex">
                                  <Link
                                    to="/school-dashboard"
                                    style={{ textDecoration: "none" }}
                                    state={{
                                      school_id: userData.princi_school,
                                      referrer: "/principal",
                                      principalName: userData.princi_name,
                                    }}
                                  >
                                    <span className="allocatedTeacher ms-2">
                                      {userData.princi_name}
                                    </span>
                                  </Link>
                                </td>
                                <td className="schoolname_text">
                                  <div className="d-flex">
                                    {userData.school_name}
                                  </div>
                                </td>
                                <td className="location_text">
                                  {userData.princi_email}
                                </td>
                                <td className="teacher_mobile">
                                  {userData.princi_mobile}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div
                        className="footer card-footer"
                        style={{ marginTop: "12px" }}
                      >
                        <div className="row">
                          {
                            <div className="result_msg_text col-lg-7 col-sm-7 sol-12">
                              Displaying {rangeEnd} results of {totalItems}
                            </div>
                          }
                          <div className="button_module col-12 col-lg-5 col-sm-5 col-md-5 d-flex ">
                            {/* <div className="title" style={{ marginRight: "16px" }}>
                    Page
                  </div> */}
                            <div
                              className="dropdown d-flex"
                              style={{
                                alignItems: "center",
                                marginRight: "10px",
                              }}
                            >
                              <p className="paginate_msg_text">Page</p>
                              <select
                                value={currentPage}
                                onChange={(e) =>
                                  setCurrentPage(Number(e.target.value))
                                }
                                className="select_page"
                                style={{
                                  marginRight: "8px",
                                  marginLeft: "16px",
                                }}
                              >
                                {Array.from({ length: totalPages }, (_, i) => (
                                  <option key={i + 1} value={i + 1}>
                                    {i + 1}
                                  </option>
                                ))}
                              </select>
                              <span className="paginate_msg_text">
                                of {totalPages}
                              </span>
                            </div>
                            <div className="d-flex">
                              <button
                                type="button"
                                className="bton"
                                onClick={prevPage}
                                disabled={currentPage === 1}
                              >
                                <img
                                  src={prevArrow}
                                  alt="prev"
                                  className="arrow_btn"
                                />
                              </button>

                              <button
                                type="button"
                                className="bton"
                                onClick={nextPage}
                                disabled={currentPage === totalPages}
                              >
                                <img
                                  src={nextArrow}
                                  alt="next"
                                  className="arrow_btn"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
          {/* modal */}
          <section className="AddPrincipal-section">
            <div
              className="modal fade"
              id="exampleModal"
              tabindex="-1"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Add Principal
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleCancel}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <form id="principalForm" onSubmit={handleFormSubmit}>
                      <div className="mb-3">
                        <label for="principalName" className="form-label">
                          Principal Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="principalName"
                          name="name"
                          value={newPrincipal.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <div className="text-danger">{errors.name}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label for="principalPhone" className="form-label">
                          Principal Phone
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="principalPhone"
                          name="phone"
                          maxLength={10}
                          value={newPrincipal.phone}
                          onChange={handleChange}
                        />
                        {errors.phone && (
                          <div className="text-danger">{errors.phone}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label htmlFor="principalEmail" className="form-label">
                          Principal Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="principalEmail"
                          name="email"
                          value={newPrincipal.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="text-danger">{errors.email}</div>
                        )}
                      </div>
                      <div class="mb-3">
                        <label for="schoolName" class="form-label">
                          School Name
                        </label>
                        {/* Map schools from API */}
                        <Select
                          isMulti={false}
                          isClearable
                          name="schoolName"
                          options={schoolOptions}
                          // value={schoolOptions.filter((option) =>
                          //   newPrincipal.schoolIds.includes(option.value)
                          // )}
                          value={
                            schoolOptions.find(
                              (option) =>
                                option.value === newPrincipal.schoolIds[0]
                            ) || null
                          }
                          onChange={handleSchoolChange}
                          placeholder="Search for a school"
                        />
                        {errors.schoolName && (
                          <div className="text-danger">{errors.schoolName}</div>
                        )}
                      </div>
                    </form>
                  </div>
                  <div class="modal-footer d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      form="principalForm"
                      className="btn btn-primary"
                      onClick={handleFormSubmit}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default Principal;
